import React from "react";
import Section from "../layout/Section";
import Title from "../layout/Title";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faBuildingColumns, faCalendarDays, faLightbulb} from "@fortawesome/free-solid-svg-icons";

const StayConnected: React.FC = () => {
    return (
        <>
            <Section>
                <Title
                    title="We are entrepreneurs, we stay connected"
                    subtitle="Dankzij onze ondernemersmindset blijven we goed geconnecteerd met de markt en zijn we steeds op de hoogte van de laatste ontwikkelingen in de technologie."
                />
                <div className="container">
                    <div className="row">
                        <div className="col-lg-4 col-md-12 col-sm-12">
                            <div className="list-icons">
                                <div className="item-icon">
                                      <span className="icon-left">
                                        <FontAwesomeIcon color="#006D77" icon={faCalendarDays} size='3x'/>
                                      </span>
                                    <h4 className="text-heading-5">1. Tech events</h4>
                                    <p className="text-inter-lg color-gray-600 mt-10">
                                        Tech events bieden ons een uitstekende kans om nieuwe contacten te leggen en
                                        bestaande contacten te onderhouden.
                                        <br/><br/>
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-12 col-sm-12">
                            <div className="list-icons">
                                <div className="item-icon">
                                      <span className="icon-left">
                                        <FontAwesomeIcon color="#006D77" icon={faLightbulb} size='3x'/>
                                      </span>
                                    <h4 className="text-heading-5">2. Technologietrends</h4>
                                    <p className="text-inter-lg color-gray-600 mt-10">
                                        Via media zoals technologierapporten, nieuwswebsites en sociale media,
                                        bestuderen we technologietrends.
                                        <br/><br/>
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-12 col-sm-12">
                            <div className="list-icons">
                                <div className="item-icon">
                                      <span className="icon-left">
                                        <FontAwesomeIcon color="#006D77" icon={faBuildingColumns} size='3x'/>
                                      </span>
                                    <h4 className="text-heading-5">3. Universiteiten en onderzoeksinstanties</h4>
                                    <p className="text-inter-lg color-gray-600 mt-10">
                                        Universiteiten en onderzoeksinstanties zetten vaak de eerste stappen voor nieuwe
                                        onderzoeken en ontdekkingen.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Section>
        </>
    );
};

export default StayConnected;